"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialTwilioIntValues = exports.TWILIO = void 0;
exports.TWILIO = "TWILIO";
exports.initialTwilioIntValues = { type: exports.TWILIO, data: { account_sid: "", token: "", from_number: "" } };
